import store from '../store'
import {
    CLEAR_API_ERROR,
    SET_API_ERROR,
} from '../reducers/errors'

/**
 * Set API error into store errors
 * @param {Object} error
 */
export const setApiErrorAction = error => {
    store.dispatch({
        type: SET_API_ERROR,
        error: error,
    })
}

/**
 * Clear API error from store errors
 */
export const clearApiErrorAction = () => {
    store.dispatch({
        type: CLEAR_API_ERROR,
    })
}
